module.exports = __webpack_public_path__ + "img/box.f8318566.webp";